import React, { useEffect, useState } from 'react';
import Layout from '../../../components/common/pageLayout';
import { v3_createNewBuildingFinalDeliveryDocumentChecksheetFields, v3_fetchNewBuildingFinalDeliveryDocumentChecksheetFields } from '../../../actions/v3/productionForm';
import { toast } from 'react-toastify';
import constant from '../../../constant';
import { ConfigMeta, toastSaveResult } from '../../../components/Production/Configure/configMeta';
import FormBuilder from '../../../components/Production/Configure/NewBuildingFinalDeliveryDocumentChecksheet'

const NewBuildingPreDeliveryCheckList = (props) => {

    const [items, setItems] = useState([{ id: '', label: '', active: true }]);

    const [showLoader, setShowLoader] = useState(false);
    // Config is global and shared; keep the version we loaded so the API can reject
    // a save made on top of someone else's newer one, and collect hard-delete ids.
    const [configMeta, setConfigMeta] = useState(null);
    const [configVersion, setConfigVersion] = useState('');
    const [deletedIds, setDeletedIds] = useState([]);


    useEffect(() => {
        setShowLoader(true);
        v3_fetchNewBuildingFinalDeliveryDocumentChecksheetFields()
            .then((res) => {
                
                if (res.status) {
                    setConfigMeta(res.result.configMeta || null);
                    setConfigVersion(res.result.configMeta?.version || '');
                    setItems(res.result.items && res.result.items.length > 0
                        ? res.result.items
                        : [{ id: '', label: '', active: true }]
                    );
                } else {
                    toast.error(res.error);
                }
            })
            .catch((error) => {
                console.error('Fetch error:', error);
                toast.error('Something went wrong while fetching.');
            })
            .finally(() => {
                setShowLoader(false);
            });
    }, []);

    const onSubmit = () => {
        setShowLoader(true);
        const payload = {
            configVersion,
            deletedIds,
            items: items.map(item => ({
                id: item.id,
                label: item.label,
                active: item.active,
            })),
        };

        v3_createNewBuildingFinalDeliveryDocumentChecksheetFields(payload)
            .then((res) => {
                if (res.status) {
                    toastSaveResult(res.result);
                    props.history.push(constant.Authedcomponent.production.url);
                } else {
                    toast.error(res.error);
                }
            })
            .catch((error) => {
                console.error('Submission error:', error);
                toast.error('Something went wrong while submitting.');
            })
            .finally(() => {
                setShowLoader(false);
            });
    };


    return (
        <Layout title={'Final Delivery Document Checksheet'}>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center">
                                            <h4>Final Delivery Document Checksheet</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 text-md-end">
                                    {/* This config is global - one shared item list per form, not per project/hull. */}
                                    <ConfigMeta meta={configMeta} />
                                </div>
                            </div>
                            <FormBuilder
                                items={items}
                                setItems={setItems}
                                onSubmit={() => { onSubmit() }}
                                onDeleteSavedItem={(id) => setDeletedIds((prev) => [...prev, id])}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};


export default NewBuildingPreDeliveryCheckList


